import styled from '@emotion/styled';
import IconButton from '__components/Kizen/IconButton';

export const StyledReorderButtons = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  min-height: 24px;
`;

export const StyledRotatedButon = styled(IconButton)`
  transform: rotate(180deg);
`;
